import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersKaizenIdeaRepliesLikedEmployeesIndexResponseType } from "~/domains";

type RequestDataType = {
  kaizenIdeaReplyId: string;
  page?: number;
};

const request = async ({
  kaizenIdeaReplyId,
  page = 1,
}: RequestDataType): Promise<ApiMembersKaizenIdeaRepliesLikedEmployeesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersKaizenIdeaRepliesLikedEmployeesIndexResponseType>(
      `/api/members/kaizen_idea_replies/${kaizenIdeaReplyId}/liked_employees`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  kaizenIdeaReplyId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersKaizenIdeaRepliesLikedEmployeesIndex = ({
  kaizenIdeaReplyId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersKaizenIdeaRepliesLikedEmployeesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersKaizenIdeaRepliesLikedEmployeesIndex", kaizenIdeaReplyId],
    ({ pageParam }) => {
      return request({
        kaizenIdeaReplyId,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
